export const PEST_FILTER_INDEX = 0;
export const APROACH_FILTER_INDEX = 1;
export const FORM_FILTER_INDEX = 2;
export const PEST_QUERY_TAG = 'pest';
export const APROACH_QUERY_TAG = 'aproach';
export const FORM_QUERY_TAG = 'form';
export const QUERY_CONNECTOR = '&';
